export const createThrottle = (callback: (args: any) => void) => {
  let calledInThisTick = false;
  let pendingTask: null | (() => any) = null;
  function executeTask(callback: () => any) {
    calledInThisTick = true;
    callback();
    // Schedule to reset the flag at the end of the current tick
    queueMicrotask(() => {
      calledInThisTick = false;
      if (pendingTask !== null) {
        const taskToRun = pendingTask;
        pendingTask = null;
        executeTask(taskToRun);
      }
    });
  }
  return function throttled(args: any) {
    if (!calledInThisTick) {
      executeTask(() => callback(args));
    } else {
      pendingTask = () => callback(args);
    }
  };
};
